import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx, _cache) {
  const _component_connector_component = _resolveComponent("connector-component")
  const _component_link_component = _resolveComponent("link-component")
  const _component_target_component = _resolveComponent("target-component")

  return (_openBlock(), _createElementBlock("div", { style: {"display":"grid","place-content":"center"} }, [
    _createElementVNode("div", {
      class: "playground",
      style: _normalizeStyle(`width: clamp(10rem, 60vw, 50rem); height: clamp(10rem, 60vw, 50rem); display: grid; grid-template-columns: repeat(${ _ctx.puzzle.block.w }, 1fr); grid-template-rows: repeat(${ _ctx.puzzle.block.h }, 1fr);`)
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(Array(_ctx.puzzle.block.h).keys()), (y) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from(Array(_ctx.puzzle.block.w).keys()), (x) => {
            return (_openBlock(), _createElementBlock("div", {
              onMouseover: $event => (_ctx.addLinkToCandidate(x, y)),
              style: _normalizeStyle(`grid-area: ${y+1}/${x+1}/${y+1}/${x+1}`)
            }, null, 44 /* STYLE, PROPS, HYDRATE_EVENTS */, ["onMouseover"]))
          }), 256 /* UNKEYED_FRAGMENT */))
        ], 64 /* STABLE_FRAGMENT */))
      }), 256 /* UNKEYED_FRAGMENT */)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle.connectors, (connector) => {
        return (_openBlock(), _createBlock(_component_connector_component, {
          id: connector.id
        }, null, 8 /* PROPS */, ["id"]))
      }), 256 /* UNKEYED_FRAGMENT */)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([..._ctx.puzzle.links, ...(_ctx.puzzle.candidate?.links || [])], (link) => {
        return (_openBlock(), _createBlock(_component_link_component, {
          key: link.id,
          id: link.id
        }, null, 8 /* PROPS */, ["id"]))
      }), 128 /* KEYED_FRAGMENT */)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle.targets, (target) => {
        return (_openBlock(), _createBlock(_component_target_component, {
          id: target.id
        }, null, 8 /* PROPS */, ["id"]))
      }), 256 /* UNKEYED_FRAGMENT */))
    ], 4 /* STYLE */)
  ]))
}